import {ACTION_CODE} from './_actionCode';
import {DashboardService} from '../../../../services';
import {ErrorModel, ResultModel} from '../../../../models';
import {LoggerService} from '../../../../services';
const FUNCTION_CODE = 'GET_ALL_DASHBOARD_CONSULTANT_WORKLOAD';

export async function getAllWorkload(userData: Record<string, any>) {
    try {
        LoggerService.logInfo('Action - getAllDashboardConsultantWorkload - Start');

        const getAllDashboardConsultantWorkload =
            await DashboardService.ConsultantService.WorkloadService.getAllWorkload(userData);

        LoggerService.logInfo('Action - getAllDashboardConsultantWorkload - End - Success');

        return ResultModel.newSuccessResult(getAllDashboardConsultantWorkload);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllDashboardConsultantWorkload - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
